import type { ComputedRef, Ref } from 'vue';
import { watch } from 'vue';

interface TagWithRedirect {
  redirect?: string;
  value?: string;
}

export function useTagRedirect(tag: Ref<TagWithRedirect> | ComputedRef<TagWithRedirect>) {
  watch(
    () => tag.value,
    (currentTag) => {
      if (currentTag?.redirect && currentTag?.value) {
        window.sendRedirectMeta?.({ toUrl: currentTag.redirect, statusCode: 301 });
        window.location.assign(currentTag.redirect);
      }
    },
    { immediate: true },
  );
}
